import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {authLoader} from '../../loader';
import {ROUTE_BALANCE_REPORT} from '../../RoutePathConstant';

const BalanceReport = lazy(() =>
  import('../../../screens/BalanceReport')
    .then(module => ({default: module.BalanceReport})));

const BalanceReportNavigation = [
  {
    path: ROUTE_BALANCE_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <BalanceReport />
      </Suspense>
    ),
  },
];

export default BalanceReportNavigation;
